import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  CreateOfferBypassRegionFilterSettingPayload,
  createOfferBypassRegionFilterSetting,
} from '~/services/PromoService';

import { offerBypassRegionFilterQueryKeys } from './offerBypassRegionFilterQueryKeys';

export function useCreateOfferBypassRegionFilterSetting() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateOfferBypassRegionFilterSettingPayload) => createOfferBypassRegionFilterSetting(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: offerBypassRegionFilterQueryKeys.lists() });
    },
  });
}
